<template>
  <Listbox as="div" v-model="locale">
    <ListboxLabel class="block align-middle text-sm font-medium text-gray-700 mb-2"> {{ $t('sidebar.language') }}:</ListboxLabel>
    <div class="mt-1 relative inline-block align-middle w-full">
      <ListboxButton class="relative w-full bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
        <span class="flex items-center" v-if="locale">
          <img :src="locale.icon" class="w-6 h-6 rounded-sm">
          <span class="ml-3 block truncate">{{ locale.name }}</span>
        </span>
        <span class="flex items-center" v-else>
          <span class="ml-3 block truncate">---</span>
        </span>
        <span class="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <SelectorIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
        </span>
      </ListboxButton>
      <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
        <ListboxOptions class="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm min-w-min">
          <ListboxOption as="template" v-for="locale in locales" :key="locale.lang" :value="locale" v-slot="{ active, selected }">
            <li :class="[active ? 'text-white bg-indigo-600' : 'text-gray-900', 'cursor-default select-none relative py-2 pl-3 pr-9 min-w-min']">
              <div class="flex items-center">
                <img :src="locale.icon" class="w-6 h-6 rounded-sm">
                <span :class="[selected ? 'font-semibold' : 'font-normal', 'ml-3 block truncate']">
                  {{ locale.name }}
                </span>
              </div>
              <span v-if="selected" :class="[active ? 'text-white' : 'text-indigo-600', 'absolute inset-y-0 right-0 flex items-center pr-4']">
                <CheckIcon class="h-5 w-5" aria-hidden="true" />
              </span>
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>

<script>

import { Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions } from '@headlessui/vue'
import { CheckIcon, SelectorIcon } from '@heroicons/vue/solid'
import dayjs from 'dayjs';

require('dayjs/locale/es');
require('dayjs/locale/pl');


export default {
  emits: ['locale-set'],
  components: {
    //
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    CheckIcon,
    SelectorIcon,
  },
  created() {
    this.locale = this.currentLocale;
  },
  computed: {
    currentLocale: function () {
      return this.locales.find(l => {
        return l.lang === this.$i18n.locale;
      });
    }
  },
  watch: {
    locale(locale) {
      if (locale) {
        this.$i18n.locale = locale.lang;
        dayjs.locale(locale.lang);
        this.$emit('locale-set', locale.lang);
      }
    },
  },
  data() {
    return {
      locale: undefined,
      locales: [
          {lang: 'en', name: this.$t('sidebar.english'), icon: require('@/assets/lang/us.svg')},
          {lang: 'pl', name: this.$t('sidebar.polish'), icon: require('@/assets/lang/pl.svg')},
          {lang: 'es', name: this.$t('sidebar.spanish'), icon: require('@/assets/lang/es.svg')},
      ],
    }
  },
}
</script>
